/**
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import mitt from 'mitt'
const dragEventBus = mitt()
export default dragEventBus
